import * as React from 'react';
import b_ from 'b_';
import { compose } from 'recompose';
import Tooltip from 'shared/components/Tooltip';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';
import SubmitButton from 'shared/components/SubmitButton';
import MoneyView from 'shared/components/MoneyView';
import { Money } from 'types/common';

import './index.scss';

interface Props {
  currentPrice: {
    exchangeTicker: string;
    price: Money;
  };
  submitting: boolean;
  error?: string;
}

type Enhanced = Props & InjectedTranslateProps;

const b = b_.with('buy-and-hold-submit-button');

const enhance = compose<Enhanced, Props>(translate);

class BuyAndHoldSubmit extends React.Component<Enhanced> {
  render() {
    const { t, currentPrice, submitting, error } = this.props;

    return (
      <Tooltip
        placement="top"
        trigger={currentPrice === null ? ['hover'] : []}
        overlay={
          <div className="rc-overlay price-comment__tooltip">{t('Cannot get current price')}</div>
        }
      >
        <div>
          <SubmitButton className={b()} submitting={submitting} error={error}>
            <div>
              <div className={b('title')}>{t('Invest')}</div>
              <div className={b('comment')}>
                {t('By price')} {this.renderPrice()}
              </div>
            </div>
          </SubmitButton>
        </div>
      </Tooltip>
    );
  }

  private renderPrice() {
    const { currentPrice } = this.props;

    if (currentPrice.price === null) {
      return '—';
    }

    return (
      <span>
        <MoneyView>{currentPrice.price}</MoneyView>
      </span>
    );
  }
}

export default enhance(BuyAndHoldSubmit);
